<template>
  <component :is="wrapper">
    <v-card-text>
      <p v-if="header" v-bind="header">{{ header.label }}</p>
    </v-card-text>
    <QueryTableWidget
      v-if="showQueryTableWidget"
      :key="dataUpdates"
      :query-id="queryId"
      :hard-filters="hardFilters"
      @deleteClicked="deleteEntry"
      @rowClick="redirectToCrudForm"
    />
    <v-btn
      color="#efca31"
      :class="addBtnClass"
      @click="showCrudFormDialog = true"
      >{{ addBtnLabel }}</v-btn
    >
    <v-dialog v-model="showCrudFormDialog" light>
      <v-card>
        <CrudForm
          class="crud-form"
          v-if="childEntityCrudForm != null"
          :key="dataUpdates"
          :entity-id="childEntityId"
          :schema-adjustments="crudSchemaAdjustments"
          :form-id="childEntityCrudForm.id"
          :schema="childEntityCrudForm.schema"
          :crud-form-redirect="crudFormRedirect"
          @entryAdded="onAddEntry"
        ></CrudForm>
        <!-- 
          :created-entity-redirect="createdEntityRedirect" -->
      </v-card>
    </v-dialog>
  </component>
</template>

<script>
import ApiService from '../APIService.js'

export default {
  name: 'ChildEntityDataWidget',
  components: {
    QueryTableWidget: () => import('../leaf_widgets/QueryTableWidget.vue'),
    CrudForm: () => import('../forms/CrudForm.vue')
  },
  props: {
    parentEntityId: {
      type: String,
      default: null
    },
    parentEntryId: {
      type: String,
      default: null
    },
    childEntityId: {
      type: String,
      required: true
    },
    childEntityAddButtonLabel: {
      type: String,
      default: 'Adaugă'
    },
    buttonStyle: {
      type: Object,
      default: null
    },
    onAddRedirectToUpdate: {
      type: Boolean,
      default: false
    },
    crudFormRedirect: {
      type: Boolean,
      default: false
    },
    queryHardFiltersOnTop: {
      type: Boolean,
      default: true
    },
    refreshForm: {
      type: Boolean,
      required: false
    },
    header: {
      type: Object,
      default: null
    },
    dismissCardView: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showCrudFormDialog: false,
      childEntityCrudForm: null,
      parentKey: null,
      queryId: null,
      dataUpdates: 0
    }
  },
  computed: {
    addBtnColor() {
      return (
        (this.buttonStyle != null ? this.buttonStyle.color : 'green') || 'green'
      )
    },
    addBtnClass() {
      return this.buttonStyle != null ? this.buttonStyle.class : null
    },
    addBtnLabel() {
      return this.buttonStyle != null && this.buttonStyle.label != null
        ? this.buttonStyle.label
        : this.childEntityAddButtonLabel
    },
    showQueryTableWidget: function() {
      return (
        this.queryId != null &&
        this.parentEntryId != null &&
        this.hardFilters != null &&
        this.parentKey != null
      )
    },
    hardFilters: function() {
      var filter = {}
      filter[`${this.parentKey}.entryId`] = this.parentEntryId
      return {
        //place on tap: true
        placeOnTop: this.queryHardFiltersOnTop,
        body: filter
      }
    },
    wrapper() {
      return this.dismissCardView == null || this.dismissCardView === false
        ? 'v-card'
        : 'div'
    },
    crudSchemaAdjustments: function() {
      var adjustments = {}
      adjustments[this.parentKey] = {
        hidden: true,
        initialValue: {
          entityId: this.parentEntityId,
          entryId: this.parentEntryId
        }
      }
      return adjustments
    }
  },
  created() {
    // console.log(
    //   "%cCreated ChildEntityDataWidget for parentEntityId: " +
    //     this.parentEntityId,
    //   "color: #f2a"
    // );
    if (this.parentKey == null) {
      ApiService.getForm(this.childEntityId, 'crud').then((response) => {
        if (response.status === 200) {
          var schema = response.data.schema
          Object.keys(schema).forEach((key) => {
            if (this.parentKey != null) return
            // ne oprim la primul match

            if (
              schema[key].type === 'ref' &&
              schema[key].entityId === this.parentEntityId
            ) {
              this.parentKey = key
              // console.log("Found parent key: " + this.parentKey);
            } else if (
              schema[key].type === 'one-of-ref' &&
              schema[key].refs != null &&
              schema[key].refs.includes(this.parentEntityId)
            ) {
              this.parentKey = key
            }
          })
        }
      })
    }
    // check if the query was specified, if not fetch the default one
    if (this.queryId == null) {
      ApiService.getForm(this.childEntityId, 'list').then((response) => {
        if (response.status === 200) {
          this.queryId = response.data.queryId
        }
      })
    }
    ApiService.getForm(this.childEntityId, 'crud').then((response) => {
      if (response.status === 200) {
        this.childEntityCrudForm = response.data
      }
    })
  },
  methods: {
    deleteEntry(value) {
      if (value._id !== null) {
        if (
          confirm('Sunteti sigur ca vreti sa continuati aceasta operatiune?')
        ) {
          ApiService.deleteEntry(this.childEntityId, value._id).then((res) => {
            if (res.response && res.response.status === 401) {
              this.$notify({
                group: 'notifications',
                type: 'error',
                title: 'Eroare',
                text: 'Nu sunteti autorizat sa efectuati aceasta actiune!'
              })
            } else if (res.status >= 200 && res.status <= 299) {
              this.$notify({
                group: 'notifications',
                type: 'error',
                title: 'DELETE',
                text: 'Entitatea s-a sters'
              })
              this.dataUpdates++
              this.$router.go(-1)
            }
          })
        }
      }
    },
    onAddEntry(newEntryId) {
      this.dataUpdates++
      this.showCrudFormDialog = false
      this.$emit('refreshRequested', {})
      if (this.refreshForm) {
        this.$emit('refreshFormRequested')
      }
      if (this.onAddRedirectToUpdate) {
        this.$router.push({
          name: 'UpdateForm',
          params: {
            entityId: this.childEntityId,
            entryId: newEntryId,
            formType: 'crud'
          }
        })
      }
    },
    redirectToCrudForm(value) {
      if (this.crudFormRedirect) {
        this.$router.push({
          name: 'UpdateForm',
          params: {
            entityId: this.childEntityId,
            entryId: value._id,
            formType: 'crud'
          }
        })
      }
    }
  }
}
</script>

<style>
.crud-form {
  width: 99.93%;
}
</style>